

export const filterDefault= {
    placeType: "Any type",
    leftPrice: 0,
    rightPrice: 1300,
    //
    amountBeds: "Any",
    amountBedrooms: "Any",
    amountBathrooms: "Any",
    propertyType: "",
    // #
    amenities: {
      essentials: [
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
      ],
      features: [
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
      ],
      location: [false, false],
    },
    isDisplayFull: false,
    //
    bookingOptions: {
      instantBook: false,
      selfCheckIn: false,
    },
  }